<template>
  <div>
    <div class="complaint-work-order">
      <div style="color: #00A551">
        <span>{{ $t('collectionCenter.reportingBranch') }}：</span>
        <span style="margin-right: 50px">{{ replyMessageData.reportSiteName }}</span>
        <span>{{ $t('customerManagements.varianceNumber') }}：</span>
        <span style="margin-right: 50px">{{ replyMessageData.detailSum }}</span>
        <span>{{ $t('GlobalSetObj.Deadline') }}：</span>
        <span>{{ replyMessageData.deadlineTime }}</span>
      </div>
      <div ref="messageListRef" class="message-content-bg">
        <div v-for="(item, index) in messageDetail" :key="index">
          <div v-if="item.createUser !== currentId" style="margin-bottom: 15px">
            <div style="text-align: left">
              <div>
                <img
                  v-if="item.type === 1"
                  :src="cs"
                  alt="cs"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else-if="item.type === 3"
                  :src="dc"
                  alt="dc"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else :src="aj" alt="aj"
                  class="img" style="width: 50px !important"
                >
              </div>
              <div style="margin-top: -60px; margin-left: 60px">
                <div>
                  <span
                    :style="{
                      color: item.type === 2 ? '#ffb907' : '#00A551'
                    }"
                  >{{ item.replyPersonName }}</span>
                  <span style="margin-left: 10px">{{ item.createTime }}</span>
                </div>
                <div>
                  <div
                    :style="{
                      float: 'left',
                      backgroundColor: item.type === 2 ? '#f6f0df' : '#ffffff'
                    }"
                    class="complaint-work-order-message-content"
                    style="word-break: break-all"
                  >
                    <div style="text-align: left" @click.stop="getImgSrc" v-html="item.replyContent" />
                    <div v-if="item.mediaUrl" style="margin-top: 10px">
                      <div
                        v-for="(list, ind) in item.urlArr"
                        :key="ind"
                        class="complaint-work-file"
                        @click="getImgSrcFile(list.url)"
                      >
                        {{ list.name }}
                      </div>
                    </div>
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </div>
          </div>
          <div v-else style="margin-bottom: 15px">
            <div style="text-align: right">
              <div>
                <img
                  v-if="item.type === 1"
                  :src="cs"
                  alt="cs"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else-if="item.type === 3"
                  :src="dc"
                  alt="dc"
                  class="img"
                  style="width: 50px !important"
                >
                <img
                  v-else :src="aj" alt="aj"
                  class="img" style="width: 50px !important"
                >
              </div>
              <div style="margin-top: -60px; margin-right: 60px">
                <div>
                  <span style="margin-right: 10px">{{ item.createTime }}</span>
                  <span
                    :style="{
                      color: item.type === 2 ? '#ffb907' : '#00A551'
                    }"
                  >{{ item.replyPersonName }}</span>
                </div>
                <div>
                  <div
                    class="complaint-work-order-message-content"
                    style="float: right; background-color: #c6e6f4;word-break: break-all"
                  >
                    <div style="text-align: right" @click.stop="getImgSrc" v-html="item.replyContent" />
                    <div v-if="item.mediaUrl" style="margin-top: 10px">
                      <div
                        v-for="(list, ind) in item.urlArr"
                        :key="ind"
                        class="complaint-work-file"
                        @click="getImgSrcFile(list.url)"
                      >
                        {{ list.name }}
                      </div>
                    </div>
                  </div>
                  <div style="clear: both" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 10px">
      <tinymce
        v-model="textarea"
        :height="180"
        :msg-plugin="msgPlugin"
        :placeholder="$t('GlobalSetObj.pleaseInputContent') + '...'"
        :toolbar="toolbar"
        :is-image="true"
      />
    </div>
    <div style="padding: 10px; text-align: right">
      <el-button
        size="small" type="primary" @click="submitMsg"
      >{{ $t('GlobalSetObj.Reply') }} </el-button><!--回复-->
    </div>
    <!-- 图片预览 -->
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imgArr" />
  </div>
</template>

<script>
import Tinymce from '@/components/Tinymce/index';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import { handoverAbnormalityGetReplyMessage, handoverAbnormalitySendReplyMessage } from '@/api/newExpressAPI';
import anjunService from '@/assets/images/anjunService.png';
import CustomerService from '@/assets/images/CustomerService.png';
import DeliveryClerk from '@/assets/images/DeliveryClerk.png';

export default {
  components: { Tinymce, ElImageViewer },
  props: {
    replyMessageData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      aj: anjunService,
      cs: CustomerService,
      dc: DeliveryClerk,
      messageDetail: [],
      textarea: '',
      getIntervalMsg: null,
      showViewer: false,
      imgArr: [],
      currentId: this.$store.state.user.id,
      fileList: [],
      msgPlugin: [''],
      toolbar: [''],
      getItem: 0
    };
  },
  mounted() {
    this.getMessageData();
    this.getIntervalMsg = setInterval(() => {
      this.getMessageData();
    }, 5000);
  },
  methods: {
    // 查看图片
    getImgSrcFile(url) {
      function getFileExtension(url) {
        // 使用正则表达式匹配最后一个点之后的部分作为文件扩展名
        const match = url.match(/\.([a-zA-Z0-9]+)(?:[\?#]|$)/);
        if (match) {
          return match[1].toLowerCase();
        }
        return '';
      }

      function isImage(extension) {
        // 定义常见的图片文件扩展名
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg'];
        return imageExtensions.includes(extension);
      }

      const extension = getFileExtension(url);
      if (isImage(extension)) {
        this.imgArr = [url];
        this.showViewer = true;
      } else {
        window.open(url);
      }
    },
    // 查看图片
    getImgSrc(e) {
      if (e.target.nodeName !== 'IMG') {
        return;
      }
      this.imgArr = [e.target.src];
      this.showViewer = true;
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    // 获取回复消息
    getMessageData() {
      const param = {
        pageNumber: 1,
        pageSize: 1000,
        params: {
          messageId: this.replyMessageData.id
        }
      };
      handoverAbnormalityGetReplyMessage(param, false).then((res) => {
        if (res.code === 200) {
          this.messageDetail = res.data.records.filter(item => item.replyContent);
          this.messageDetail.forEach((item) => {
            if (!this.isHtml(item.mediaUrl)) {
              let imgArr = [];
              if (item.mediaUrl) {
                imgArr = item.mediaUrl.split(',');
              }
              let str = '';
              if (imgArr.length > 0) {
                imgArr.forEach((item1, index) => {
                  if (index === 0) {
                    str += `<img src="${item1}" alt="">`;
                  } else {
                    str += `<img src="${item1}" alt="">`;
                  }
                });
                item.replyContent = `<p>${item.replyContent}</p>${str}`;
              } else {
                item.replyContent = `<p>${item.replyContent}</p>`;
              }
            }
          });
          if (this.getItem === 0) {
            this.scrollToBottom();
            this.getItem++;
          }
        }
      });
    },
    // 判断是否是存在html标签
    isHtml(str) {
      const reg = /<[^>]+>/g;
      return reg.test(str);
    },
    // 提交回复
    submitMsg() {
      if (this.textarea === '') {
        this.$message.warning(this.$t('collectionCenter.messageContentRequired')); // 消息内容不能为空
        return;
      }
      const param = {
        messageId: this.replyMessageData.id,
        message: this.textarea
      };
      handoverAbnormalitySendReplyMessage(param, false).then((res) => {
        if (res.code === 200) {
          this.getMessageData();
          this.textarea = '';
          this.fileList = [];
          this.scrollToBottom();
        }
      });
    },
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        // 延迟 100ms 确保所有内容加载完成
        setTimeout(() => {
          this.$refs.messageListRef.scrollTo(0, this.$refs.messageListRef.scrollHeight);
        }, 100);
      });
    }
  }
};
</script>

<style>
.message-content-bg {
  overflow-y: auto;
  background-color: #f5f5f5;
  padding: 10px 5px;
  height: 100%;
  border-radius: 5px;
}

.complaint-work-order {
  height: calc(100vh - 406px);
  border-radius: 5px;
  padding: 10px;
}

.complaint-work-order-message-content {
  padding: 15px;
  border-radius: 5px;
}

.complaint-work-order-message-content img {
  width: 160px;
}

.complaint-work-order-message-content * {
  word-wrap: break-word;
  white-space: pre-wrap;
}

.complaint-work-order-message-content p {
  margin: 0;
}

.complaint-work-order-message-content a:hover {
  color: #00A551;
  text-decoration: underline;
}

.files-update-complaint-work .el-upload-list {
  height: 35px;
  overflow-y: auto;
}

.complaint-work-file {
  line-height: 16px;
  cursor: pointer;
}

.complaint-work-file:hover {
  color: #00A551;
  text-decoration: underline;
}
</style>
